<h1 mat-dialog-title>Agregar Referencias</h1>
<div mat-dialog-content>
    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
        <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
        <input matInput formControlName="firstName" placeholder="Nombre de la ruta" required>
        <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
        <input matInput formControlName="lastName" placeholder="Dirección URL" required>
    </div>

    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">

        <mat-form-field appearance="outline" fxFlex="100">
            <mat-label>Country</mat-label>
            <mat-select formControlName="country" required>
                <mat-option [value]="'United States of America'">
                    United States of America
                </mat-option>
                <mat-option [value]="'United Kingdom'">
                    United Kingdom
                </mat-option>
                <mat-option [value]="'Russia'">
                    Russia
                </mat-option>
                <mat-option [value]="'China'">
                    China
                </mat-option>
                <mat-option [value]="'Japan'">
                    Japan
                </mat-option>
                <mat-option [value]="'Turkey'">
                    Turkey
                </mat-option>
            </mat-select>
            <mat-icon matSuffix class="secondary-text">outlined_flag</mat-icon>
            <mat-error>Country is required!</mat-error>
        </mat-form-field>

    </div>




</div>
<div mat-dialog-actions>
    <button mat-button (click)="onNoClick()">No Thanks</button>
    <button mat-button [mat-dialog-close]="data.animal" cdkFocusInitial>Ok</button>
</div>